import { endpoints } from 'Constants';

const fileServices = {
	upload: (file) => ({
		baseURL: endpoints.FILE.UPLOAD(),
		method: 'POST',
		data: file.formData,
	}),

	delete: (params) => ({
		baseURL: endpoints.FILE.DELETE(params),
		method: 'DELETE',
	}),

	readFromPath: (params) => ({
		baseURL: endpoints.FILE.READ_FROM_PATH(params.path),
		method: 'GET',
		responseType: 'blob',
	}),
};

export default fileServices;
